import './OrderTablePopUpMenu.style.less'

import { Button, Dropdown, Menu } from 'antd'
import {
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  MoreOutlined,
} from '@ant-design/icons'

import { pbfOrderAtom } from '@/screens/Order/jotai/order.jotai'
import { useAtom } from 'jotai'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import ModalConfirm from '@/components/ModalConfirm/ModalConfirm'
import { useMutation } from 'react-query'
import { deleteOrder } from '../../OrderTable.transform'
import { queryClient } from '@/config/react-query'
import { hiddenOrderPropertiesFN } from '@/utils/common'
import { PBF_QUERY_KEY } from '@/constant/pbf'
import LoadingComponent from '@/components/LoadingComponent/LoadingComponent'
interface Props {
  data?: any
  editable: boolean
  clone: boolean
  deletable: boolean
  hideActions?: any
}

function OrderTablePopUpMenu({
  data,
  editable,
  clone,
  deletable,
  hideActions,
}: Props) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [, setOrder] = useAtom(pbfOrderAtom)
  const [modalDeleteOrder, setModalDeleteOrder] = useState(false)

  const onClone = () => {
    setOrder(null)
    navigate(`/pbf/orders/edit-order?id=${data.id}&type=clone`)
  }

  const deleteMutation = useMutation(async () => {
    await deleteOrder(data.id)
  })

  return (
    <>
      <Dropdown
        trigger={['click']}
        disabled={!editable && !clone && !deletable}
        overlay={
          <Menu>
            {editable && (
              <Menu.Item key="1" className="menuButton">
                <Button
                  hidden={hiddenOrderPropertiesFN(hideActions, 'update')}
                  size="large"
                  onClick={() => {
                    navigate(`/pbf/orders/edit-order/${data?.id}`)
                  }}
                >
                  <EditOutlined />
                  {t('pbf.option.edit')}
                </Button>
              </Menu.Item>
            )}
            {clone && (
              <Menu.Item key="2" className="menuButton">
                <Button size="large" onClick={onClone}>
                  <CopyOutlined />
                  {t('pbf.option.clone')}
                </Button>
              </Menu.Item>
            )}
            {deletable && (
              <Menu.Item key="2" className="menuButton">
                <Button size="large" onClick={() => setModalDeleteOrder(true)}>
                  <DeleteOutlined />
                  Delete
                </Button>
              </Menu.Item>
            )}
          </Menu>
        }
      >
        <Button className="button-more">
          <MoreOutlined />
        </Button>
      </Dropdown>
      {modalDeleteOrder && (
        <ModalConfirm
          onOK={async () => {
            await deleteMutation.mutateAsync()
            await queryClient.refetchQueries(['PBF_ORDERS'])
            await queryClient.refetchQueries(['orderGroupQuery'])
            await queryClient.invalidateQueries([
              PBF_QUERY_KEY.PBF_ORDERS_ADVANCE_SUMMARY,
            ])
            setModalDeleteOrder(false)
          }}
          loading={deleteMutation.isLoading}
          onCancel={null}
          confirmButtonText="Yes, Delete"
          cancelButtonText="No, Cancel"
          title="Delete order"
          type="delete"
          content={
            <div>
              Are you sure you want to delete the order no.{' '}
              <strong>{data?.number}</strong>? You won’t be able to access it
              anymore.
            </div>
          }
          open={modalDeleteOrder}
          onClose={() => setModalDeleteOrder(false)}
        />
      )}
      {deleteMutation.isLoading && <LoadingComponent />}
    </>
  )
}

export default OrderTablePopUpMenu
